import React from "react";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import RoomIcon from "@mui/icons-material/Room";
import "./ClusterPopup.css";

const ClusterPopup = ({ stops, onClose, onStopClick }) => {
  const { t } = useTranslation();

  if (!stops || stops.length === 0) return null;

  // Sort stops by their original index order
  const sortedStops = [...stops].sort((a, b) => a.stopIndex - b.stopIndex);

  return (
    <div className="cluster-popup-overlay" onClick={onClose}>
      <div className="cluster-popup" onClick={(e) => e.stopPropagation()}>
        <div className="cluster-popup-header">
          <span className="cluster-popup-title">
            {stops.length} {t("passenger.title")}
          </span>
          <button className="cluster-popup-close" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </button>
        </div>
        <div className="cluster-popup-list">
          {sortedStops.map((stop, idx) => (
            <div
              key={stop.stopId || idx}
              className="cluster-popup-item"
              onClick={() => onStopClick && onStopClick(stop)}
            >
              <RoomIcon className="cluster-popup-item-icon" />
              <span className="cluster-popup-item-index">{stop.stopIndex}.</span>
              <span className="cluster-popup-item-name">{stop.stopName}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClusterPopup;
